var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSaveEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2337",
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2341"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2351"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2349",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2343",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2347",
    clipPath: "url(#clipPath2351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2353",
    transform: "translate(267.1802,420.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -117.34,-28.43 c -1.48,-0.37 -2.96,-0.55 -4.41,-0.55 -9.62,0 -17.93,7.81 -17.93,17.97 0,6.78 3.82,12.98 9.87,16.04 L 20.37,80.8 c 7.78,3.93 16.87,4.28 24.93,0.96 L 172.14,29.59 c 3.25,-1.34 6.61,-2.38 10.02,-3.12 0.19,-0.04 0.37,-0.08 0.56,-0.11 5.29,-1.11 10.72,-1.5 16.15,-1.15 l 38.45,6.58",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2355",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2357",
    transform: "translate(352.7427,357.5649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 29.387,-19.995 c 21.27,-14.47 47.42,-19.87 72.67,-15.02 l 49.7,9.56",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2359",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2361",
    transform: "translate(371.6099,416.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -10.71,3.21 -21.42,6.42 -32.14,9.63 l -11.36,3.4 -35.09,10.51 c -8.25,3.69 -17.79,1.44 -23.03,-5.16 -0.22,-0.27 -0.43,-0.55 -0.62,-0.84 -2.84,-4.04 -3.44,-8.92 -2.19,-13.33 1.09,-3.91 3.64,-7.45 7.38,-9.72 l 56.559,-38.482",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2363",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2365",
    transform: "translate(7.5,59.7305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 38.45,6.579 C 43.88,6.93 49.31,6.539 54.6,5.43 c 0.19,-0.031 0.37,-0.071 0.56,-0.111 3.41,-0.74 6.77,-1.78 10.02,-3.12 l 126.84,-52.17 c 8.06,-3.319 17.15,-2.969 24.93,0.96 L 367.13,26.76 c 6.05,3.059 9.87,9.26 9.87,16.04 0,10.16 -8.31,17.97 -17.93,17.97 -1.45,0 -2.93,-0.18 -4.41,-0.55 L 237.32,31.789",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2367",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2369",
    transform: "translate(140.3901,95.7305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 10.71,-3.211 21.42,-6.421 32.14,-9.631 L 43.5,-13.03 78.59,-23.54 c 8.25,-3.69 17.79,-1.44 23.03,5.159 0.22,0.271 0.43,0.551 0.62,0.841 2.84,4.04 3.44,8.92 2.19,13.329 -1.09,3.91 -3.64,7.45 -7.38,9.721 L -10.52,78.699 C -31.79,93.17 -57.94,98.569 -83.19,93.72 l -49.7,-9.561",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2371",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2373",
    transform: "translate(176.3413,186.2305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -16.333,18.633 -26.233,43.045 -26.233,69.77 0,58.482 47.409,105.891 105.892,105.891 58.482,0 105.891,-47.409 105.891,-105.891 0,-58.483 -47.409,-105.892 -105.891,-105.892 -20.938,0 -40.456,6.077 -56.888,16.562",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2375",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2377",
    transform: "translate(275.4556,327.9399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 5.99,0.048 9.984,-5.447 7.978,-10.627 -5.332,-13.767 -11.234,-27.36 -16.989,-40.956 -0.349,-0.823 -0.099,-1.166 0.582,-1.56 10.777,-6.221 21.529,-12.483 32.315,-18.686 5.314,-3.055 6.16,-9.274 1.726,-13.48 -19.537,-18.533 -39.104,-37.033 -58.664,-55.541 -3.281,-3.105 -6.512,-3.809 -9.875,-2.18 -3.664,1.774 -5.462,5.943 -3.967,9.807 2.041,5.274 4.277,10.473 6.449,15.696 3.503,8.425 7.008,16.85 10.558,25.255 0.363,0.857 0.058,1.163 -0.602,1.543 -10.91,6.274 -21.928,12.422 -32.702,18.926 -5.016,3.028 -5.608,9.202 -1.332,13.253 19.548,18.522 39.154,36.985 58.664,55.548 C -4.06,-1.291 -2.085,-0.068 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2379",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveEnergy);
export default __webpack_public_path__ + "static/media/icon-save-energy.3c4a5f9d5fba4877d3a72de6cb5ff23f.svg";
export { ForwardRef as ReactComponent };